import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import firebase from "../../util/firebaseConfig";

import { Grid, Header, Image } from "semantic-ui-react";

import logo from "../../assets/visual/loader.gif";
import Main from "../Temp/Main";
import Payment from "./Payment";

const Home = () => {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const isVerified = useSelector((state) => state.firebase.auth.emailVerified);
  const [state, setState] = useState({
    loader: true,
    caseId: 0,
  });
  useEffect(() => {
    const db = firebase.firestore();
    db.collection("profile")
      .doc(uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          // if (isVerified) {
          //   setState({
          //     loader: false,
          //     caseId: 2,
          //   });
          // } else {
          //   setState({
          //     loader: false,
          //     caseId: -1,
          //   });
          // }
          setState({
            loader: false,
            caseId: -1,
          })
        } else {
          setState({
            loader: false,
            caseId: 1,
          });
        }
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!uid) return <Redirect to="/signin" />;
  // if (state.caseId === -1) return <Redirect to="/verify-email" />;
  if (state.caseId === 1) return <Redirect to="/profile" />;
  return state.loader ? (
    <>
      <Grid textAlign="center" verticalAlign="middle">
        <Image src={logo} />
      </Grid>
      <Header textAlign="center">Loading...</Header>
    </>
  ) : (
    <Main />
  );
};

export default Home;

// if (doc.data().authority === "Collaborator") {
//   setState({
//     // Collaborator
//     loader: false,
//     caseId: 2,
//   });
// } else {
//   if (isVerified) {
//     db.collection("customers")
//       .doc(uid)
//       .collection("subscriptions")
//       .get()
//       .then((snap) => {
//         if (snap.size === 0) {
//           setState({
//             // Subscription Yok
//             loader: false,
//             caseId: 0,
//           });
//         } else {
//           snap.forEach((doc) => {
//             if (doc.exists) {
//               // Subscription Var
//               db.collection("profile")
//                 .doc(uid)
//                 .get()
//                 .then((doc) => {
//                   // Profile var
//                   if (doc.exists) {
//                     setState({
//                       loader: false,
//                       caseId: 2,
//                     });
//                   } else {
//                     // Profile Yok
//                     setState({
//                       loader: false,
//                       caseId: 1,
//                     });
//                   }
//                 });
//             }
//           });
//         }
//       });
//   } else {
//     setState({
//       loader: false,
//       caseId: -1,
//     });
//   }
// }

// return state.loader ? (
//   <>
//     <Grid textAlign="center" verticalAlign="middle">
//       <Image src={logo} />
//     </Grid>
//     <Header textAlign="center">Loading...</Header>
//   </>
// ) : state.caseId === 2 ? (
//   <Main />
// ) : (
//   <>
//     <Payment />
//   </>
// );
